var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 18.333c0-.253-.205-.458-.458-.458H1.833c-.253 0-.458.205-.458.458v3.209h2.75v-3.209zM9.625 13.75c0-.253-.205-.458-.458-.458H7.333c-.253 0-.458.205-.458.458v7.792h2.75V13.75zM15.125 16.5c0-.253-.205-.458-.458-.458h-1.834c-.253 0-.458.205-.458.458v5.042h2.75V16.5zM20.625 9.167c0-.253-.205-.459-.458-.459h-1.834c-.253 0-.458.206-.458.459v12.375h2.75V9.167zM.462 21.542L21.545 21.542M3.591 7.87L6.041 5.421M8.921 5.049L11.253 6.409M14.279 6.2L17.812 3.425"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.254,
    cy: 2.292,
    r: 1.833
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.837,
    cy: 7.333,
    r: 1.833
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.337,
    cy: 4.125,
    r: 1.833
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.295,
    cy: 9.167,
    r: 1.833
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureAnalytics);
export default __webpack_public_path__ + "static/media/azure-analytics.306257ab.svg";
export { ForwardRef as ReactComponent };